import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, async } from "rxjs";
import { environment } from "../../../environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  BASE_URLS: any = {
    serverUrlPublic: environment.webApiUrl,
  };

  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private httpClient: HttpClient
  ) {}

  get(
    endpoint: string,
    {
      targetApi = "serverUrlPublic",
      customUrl = "",
      ngxSpinner = true,
      customSpinner = false,
      showError = true,
    }
  ): Observable<any> {
    const finalUrl = this.parseUrl(endpoint, customUrl, targetApi);

    if (ngxSpinner) this.spinner.show();

    return new Observable((obs) => {
      this.httpClient.get(finalUrl).subscribe({
        next:   (res) => {
          if (ngxSpinner)   this.spinner.hide();
          obs.next(res);
        },
        error:   (error: HttpErrorResponse) => {
          if (ngxSpinner)  this.spinner.hide();
          this.handleApiError(error, showError, ngxSpinner);
          obs.error(error.error);
          obs.complete();
        },
      });
    });
  }

  post(
    endpoint: string,
    body: object,
    {
      targetApi = "serverUrlPublic",
      customUrl = "",
      ngxSpinner = true,
      showError = true,
    },
    headers?: Object
  ): Observable<any> {
    const finalUrl = this.parseUrl(endpoint, customUrl, targetApi);
    if (ngxSpinner) this.spinner.show().catch();

    return new Observable((obs) => {
      this.httpClient.post(finalUrl, body, headers).subscribe({
        next:  (res) => {
          if (ngxSpinner)  this.spinner.hide().catch();
          obs.next(res);
          obs.complete();
        },
        error:   (error: HttpErrorResponse) => {
          if (ngxSpinner)  this.spinner.hide().catch();
          this.handleApiError(error, showError, ngxSpinner);
          obs.error(error.error);
          obs.complete();
        },
      });
    });
  }

  put(
    endpoint: string,
    body: object,
    {
      targetApi = "serverUrlPublic",
      customUrl = "",
      ngxSpinner = true,
      showError = true,
    }
  ): Observable<any> {
    const finalUrl = this.parseUrl(endpoint, customUrl, targetApi);

    if (ngxSpinner) this.spinner.show().catch();

    return new Observable((obs) => {
      this.httpClient.put(finalUrl, body).subscribe({
        next: (res) => {
          if (ngxSpinner) this.spinner.hide().catch();
          obs.next(res);
          obs.complete();
        },
        error: (error: HttpErrorResponse) => {
          if (ngxSpinner)this.spinner.hide().catch();
          this.handleApiError(error, showError, ngxSpinner);
          obs.error(error.error);
          obs.complete();
        },
      });
    });
  }
  parseUrl(
    endpoint: any,
    customUrl: any,
    targetApi = "serverUrlPublic"
  ): string {
    const finalUrl = customUrl || this.BASE_URLS[targetApi];
    return finalUrl + "/" + endpoint;
  }

  handleApiError(
    error: HttpErrorResponse,
    showError: boolean,
    ngxSpinner: boolean
  ): void {
    if (ngxSpinner) this.spinner.hide();
    if(showError) this.toastError(error.status);
  
  }

  toastError(errorCode: any): void {
    this.toastr.error(
      "Error interno del servidor, por favor inténtelo de nuevo más tarde"
    );
  }
}
